import { SellerProperties } from '../../store/seller/seller-properties';
import { UserPermissionService } from '../../services/user-permission-service';
import Global from '../../store/global-selectors';

const inventoryIsDisabled = (state) => {
  const userRoles = Global.selectUseruserRoles(state);
  const { isInventoryEnabled } = new SellerProperties({ state });
  const canManageInventory = UserPermissionService.userHasInventoryManagementRole(userRoles);

  return !isInventoryEnabled || !canManageInventory;
};

export default inventoryIsDisabled;
